enum ServiceComboItemType {
    Service = 1,
    Combo = 2
}

export { ServiceComboItemType };
